import MoneyFormat from './MoneyFormat';

export default class DataTable {
    static gerarColunas(controler, map, params) {
        let arr = this.recuperarColunasPadrao(controler, map);
        const XFIELDS = this.getObjectByControler(controler, params);
        
        for (var key in XFIELDS) {
            const cat = XFIELDS[key];
            let dat;
            dat = {
                title: cat.label, data: map[cat.label] ? map[cat.label] : cat.label, render: (dado) => {
                    return dado ? dado : "--";
                },
            };
            arr.push({ ...dat, visible: Number(cat.display) == 1 });
        }
        console.warn(arr);
        return arr;
    }

    static getObjectByControler(controler, params) {
        let obj;
        switch (controler) {
            case 'products':
                obj = params.ProductXFields;
                break;
            case 'clients':
                obj = params.ClientXFields;
                break;
            case 'agents':
                obj = params.AgentsXFields;
                break;
            default:
                obj = {}
                break;
        }
        return obj;
    }

    static recuperarColunasPadrao(controler, map) {
        let arr;
        switch (controler) {
            case 'products':
                arr = [
                    //COLUNAS DEFAULT
                    {
                        title: "Ações",
                        data: "null",
                        render: () => {
                            return `<div id="data-table-acoes"><i class="el-icon-edit"></i><i class="el-icon-delete"></i></div>`
                        }
                    },
                    { title: "#", data: "id" },
                    {
                        title: "Imagem",
                        data: "image",
                        render: (image) => {
                            return image ? image : "";
                        },
                    },
                    { title: "Nome", data: map.name },
                    {
                        title: "Preço",
                        data: map.price,
                        render: (dinheiro) => {
                            return MoneyFormat(dinheiro);
                        },
                    },
                    {
                        title: "Estoque",
                        data: map.amount,
                        render: (data, type, row) => {
                            const unidade = row[map.equivalent_unit];
                            return (data ? data : '') + (unidade && unidade != '--' ? unidade : '');
                        }
                    }
                ];
                break;
            case 'clients':
                arr = [
                    //COLUNAS DEFAULT
                    { title: "#", data: "id" },
                    { title: "Nome", data: map.name },
                    { title: "Data de Nascimento", data: map["Data de Nascimento"] },
                    {
                        title: "Tipo Sanguíneo",
                        data: "Tipo Sanguíneo",
                        render: (data) => {
                            return data ? data : "--";
                        },
                    },
                    // {
                    //     title: "Telefone",
                    //     data: map.Telefone,
                    // },
                    // {
                    //     title: "E-mail",
                    //     data: map["E-mail"],
                    // },
                ];
                break;
            case 'agents':
                arr = [
                    //COLUNAS DEFAULT
                    { title: "#", data: "id" },
                    { title: "Nome", data: map.name },
                ];
                break;
            default:
                arr = []
                break;
        }
        return arr;
    }
}